// extracted by mini-css-extract-plugin
export default {"root":"applications-components-ItemApp-components-Author-author-module__root","label":"applications-components-ItemApp-components-Author-author-module__label","value":"applications-components-ItemApp-components-Author-author-module__value","inventory":"applications-components-ItemApp-components-Author-author-module__inventory"};
    if(module.hot) {
      // 1723799412613
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  